import { useDispatch, useSelector } from "react-redux";
import { AppAction, AppSel, AppType } from "@/features/applications/index";
import { firebaseDb } from "@/infrastructure/firebase";

export const useUserPreference = () => {
  const dispatch = useDispatch();
  const userDocName = useSelector(AppSel.userDocName);

  return {
    userPreference: useSelector(AppSel.userPreference),
    updateUserPreference: (newPreference: AppType.UserPreference) => {
      const data = { userPreference: newPreference };
      dispatch(AppAction.updateUserInfo(data));

      firebaseDb
        .collection("users")
        .doc(userDocName)
        .update(data);
    }
  };
};

export const useWatchListUpdate = () => {
  const dispatch = useDispatch();
  const userDocName = useSelector(AppSel.userDocName);

  return {
    userDocName,
    userWatchlist: useSelector(AppSel.userWatchlist),
    updateWatchlist: (newWatchlist: Record<string, AppType.TickerExchange[]>) => {
      const data = { watchlist: newWatchlist };
      dispatch(AppAction.updateUserInfo(data));

      firebaseDb
        .collection("users")
        .doc(userDocName)
        .update(data);
    }
  };
};
